/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query LegaloverviewQuery($uid: String!) {
    prismic {
      legaloverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_LegaloverviewBodyDocumentlist {
          type
            label
            primary {
              text_color
              background_color
              background_image
              heading
              heading_color
              subheading
              subheading_color
            }
            fields {
              section_heading
              link_1 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_1_text
              link_2 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_2_text
              link_3 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_3_text
              link_4 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_4_text
              link_5 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_5_text
              link_6 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_6_text
              link_7 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_7_text
              link_8 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_8_text
              link_9 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_9_text
              link_10 {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_10_text
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Legaloverview = ({ data, location }) =>
  data.prismic.legaloverview ? (
    <MainLayout location={location} layout='legaloverview'>
    <Helmet>
      <title>{(data.prismic.legaloverview.title[0] && data.prismic.legaloverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.legaloverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.legaloverview.path : 'https://www.digitalocean.com' + data.prismic.legaloverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.legaloverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.legaloverview.title[0] ? data.prismic.legaloverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.legaloverview.description ? data.prismic.legaloverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.legaloverview.open_graph_image ? data.prismic.legaloverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.legaloverview.description ? data.prismic.legaloverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.legaloverview.title[0] ? data.prismic.legaloverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.legaloverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.legaloverview.path : 'https://www.digitalocean.com' + data.prismic.legaloverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.legaloverview.open_graph_image ? data.prismic.legaloverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.legaloverview.body} />
    </MainLayout>
  ) : null;

Legaloverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Legaloverview;
